<template>
  <div class="body-div">
    <div class="main-nav styleCard">
      <ul class="style-nav style1">
        <li
          v-for="tab in timeTabs"
          :key="tab.id"
          class="router-link"
          @click="selectedTimeTab = tab.alias"
          :class="{ active: selectedTimeTab === tab.alias }"
        >
          {{ tab.name }}
        </li>
      </ul>
    </div>

    <div class="top-div" v-if="selectedTimeTab === 'TODAY'">
      <div class="table">
        <table
          v-if="
            !Array.isArray(proClub[0]) &&
              proClub[0].total_clients_in_time_frame > 0
          "
        >
          <thead>
            <tr class="text-center">
              {{
                GetTimeText("0")
              }}
              |
              {{
                proClub[0].total_clients_in_time_frame
              }}
              |
              {{
                proClub[0].total_deposits_in_time_frame
              }}
            </tr>
          </thead>
          <tbody>
            <table>
              <tr>
                <td v-for="cond in proClub[0].campaign_aaid" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[0].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[0].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in proClub[0].users" :key="cond.id">
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}
                    | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[0].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[0].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%
                  </span>
                </td>
              </tr>
              <tr>
                <td v-for="cond in proClub[0].country_id" :key="cond.id">
                  <span
                    >{{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                    | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[0].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[0].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in proClub[0].keyword" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[0].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[0].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
            </table>
          </tbody>
        </table>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          proClubBusy[0] || proClubBusy[1] || proClubBusy[30] || proClubBusy[90]
        "
      ></loader>
    </div>
    <div class="top-div" v-if="selectedTimeTab === 'YESTERDAY'">
      <div class="table">
        <table
          v-if="
            !Array.isArray(proClub[1]) &&
              proClub[1].total_clients_in_time_frame > 0
          "
        >
          <thead>
            <tr class="text-center">
              {{
                GetTimeText("1")
              }}
              |
              {{
                proClub[1].total_clients_in_time_frame
              }}
              |
              {{
                proClub[1].total_deposits_in_time_frame
              }}
            </tr>
          </thead>
          <tbody>
            <table>
              <tr>
                <td v-for="cond in proClub[1].campaign_aaid" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[1].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[1].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in proClub[1].users" :key="cond.id">
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}
                    | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[1].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[1].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%
                  </span>
                </td>
              </tr>
              <tr>
                <td v-for="cond in proClub[1].country_id" :key="cond.id">
                  <span
                    >{{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                    | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[1].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[1].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in proClub[1].keyword" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[1].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[1].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
            </table>
          </tbody>
        </table>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          proClubBusy[0] || proClubBusy[1] || proClubBusy[30] || proClubBusy[90]
        "
      ></loader>
    </div>
    <div class="top-div" v-if="selectedTimeTab === '30DAYS'">
      <div class="table">
        <table
          v-if="
            !Array.isArray(proClub[30]) &&
              proClub[30].total_clients_in_time_frame > 0
          "
        >
          <thead>
            <tr class="text-center">
              {{
                GetTimeText("30")
              }}
              |
              {{
                proClub[30].total_clients_in_time_frame
              }}
              |
              {{
                proClub[30].total_deposits_in_time_frame
              }}
            </tr>
          </thead>
          <tbody>
            <table>
              <tr>
                <td v-for="cond in proClub[30].campaign_aaid" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[30].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[30].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in proClub[30].users" :key="cond.id">
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}
                    | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[30].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[30].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%
                  </span>
                </td>
              </tr>
              <tr>
                <td v-for="cond in proClub[30].country_id" :key="cond.id">
                  <span
                    >{{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                    | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[30].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[30].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in proClub[30].keyword" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[30].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[30].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
            </table>
          </tbody>
        </table>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          proClubBusy[0] || proClubBusy[1] || proClubBusy[30] || proClubBusy[90]
        "
      ></loader>
    </div>
    <div class="top-div" v-if="selectedTimeTab === '90DAYS'">
      <div class="table">
        <table
          v-if="
            !Array.isArray(proClub[90]) &&
              proClub[90].total_clients_in_time_frame > 0
          "
        >
          <thead>
            <tr class="text-center">
              {{
                GetTimeText("90")
              }}
              |
              {{
                proClub[90].total_clients_in_time_frame
              }}
              |
              {{
                proClub[90].total_deposits_in_time_frame
              }}
            </tr>
          </thead>
          <tbody>
            <table>
              <tr>
                <td v-for="cond in proClub[90].campaign_aaid" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[90].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[90].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in proClub[90].users" :key="cond.id">
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}
                    | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[90].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[90].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%
                  </span>
                </td>
              </tr>
              <tr>
                <td v-for="cond in proClub[90].country_id" :key="cond.id">
                  <span
                    >{{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                    | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[90].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[90].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in proClub[90].keyword" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.rate }}% | {{ cond.amount }} |
                    {{ proClub[90].total_clients_in_time_frame }}
                    |
                    {{ cond.deposits }} |
                    {{
                      (
                        (100 * cond.amount) /
                        proClub[90].total_clients_in_time_frame
                      ).toFixed(2)
                    }}%</span
                  >
                </td>
              </tr>
            </table>
          </tbody>
        </table>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          proClubBusy[0] || proClubBusy[1] || proClubBusy[30] || proClubBusy[90]
        "
      ></loader>
    </div>
    <div class="bottom-div" v-if="false">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >
      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
export default {
  name: "ProClub.container",
  components: { Loader },
  data() {
    return {
      proClubBusy: {
        0: false,
        1: false,
        30: false,
        90: false
      },
      proClub: {
        0: [],
        1: [],
        30: [],
        90: []
      },
      timeTabs: [
        {
          id: 0,
          name: "Today",
          alias: "TODAY"
        },
        {
          id: 1,
          name: "Yesterday",
          alias: "YESTERDAY"
        },
        {
          id: 2,
          name: "Last 30 Days",
          alias: "30DAYS"
        },
        {
          id: 3,
          name: "Last 90 Days",
          alias: "90DAYS"
        }
      ],
      selectedTimeTab: "TODAY"
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "selectedStatisticsTimeFrameTab"
    ])
  },
  created() {
    this.getProClubByTimeFrame(0);
    this.getProClubByTimeFrame(1);
    this.getProClubByTimeFrame(30);
    this.getProClubByTimeFrame(90);

    this.selectedTimeTab = this.selectedStatisticsTimeFrameTab;
  },
  watch: {
    selectedTimeTab: function() {
      this.$store.commit(
        "clients/setSelectedStatisticsTimeFrameTab",
        this.selectedTimeTab
      );
    }

    // selectedStatisticsTimeFrameTab: function () {
    //   this.selectedTimeTab = this.selectedStatisticsTimeFrameTab
    // }
  },
  methods: {
    async getProClubByTimeFrame(timeFrame) {
      if (
        !this.proClubBusy[timeFrame] &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.proClubBusy[timeFrame] = true;
          const res = await apiClientCreator(
            `reports/pro_club/${timeFrame}/true`
          ).get("");
          this.proClub[timeFrame] = res.data;
          this.proClubBusy[timeFrame] = false;
        } catch (e) {}
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    GetTimeText(time) {
      if (time === "0") return "Today";
      if (time === "1") return "Yesterday";
      else return "Last " + time + " days";
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  height: 650px;
  overflow-y: scroll;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
}
.bottom-div {
  width: 100%;
  height: 650px;
  overflow-y: scroll;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
.table {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.table td {
  padding: 0.3em 0;
}
.table table {
  font-size: 13px;
  width: 1500px;
  margin: 3em 0;
}
.table thead {
  border-bottom: solid 2px #eff3f6;
}
.table tfoot {
  border-top: solid 2px #eff3f6;
  color: red;
}
.table th {
  text-align: center;
}
.text-center {
  font-weight: bold;
}
.loader {
  left: 0;
  right: 0;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
}
.style-nav .router-link {
  max-width: 150px;
  min-width: 72px;
  height: 28px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 11px;
  color: black;
  text-align: center;
  vertical-align: middle;
  line-height: 28px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.3s ease, color 0.3s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 .router-link:not(.empty):hover {
  background: #44a2d2;
  color: white;
  text-decoration: none;
}

.style-nav.style1 .router-link.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  text-decoration: none;
}
</style>
